export default __webpack_public_path__ + "static/media/php.a2131666.svg";